import { Injectable } from '@angular/core'
import { Http } from '@angular/http'
import {BaseService} from "./base-service";
import {Settings} from "../settings/base";


@Injectable()
export class VisitService extends BaseService {


  constructor(private http: Http, private _settings: Settings) {

    super();
  }

  getVisits() {

    return this.http.get(this._settings.base_url+ "visits/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

   getPatientsVisits(patient_id) {

    return this.http.get(this._settings.base_url+ "patients/visits/"+patient_id+"/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  checkVisitStatus(patient_id){
    return this.http.get(this._settings.base_url+ "visits/status/"+patient_id+"/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }


  getVisit(id) {
    return this.http.get(this.getVisitUrl(id), this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  addVisit(visit){
    return this.http.post(this._settings.base_url+ "visits/",JSON.stringify(visit),this.createHeaders("Authorization"))
      .map(res => res.json());
  }

   private getVisitUrl(id) {
    return this._settings.base_url+ "visits/" + id+"/";

  }

}



// WEBPACK FOOTER //
// ./src/providers/visit.service.ts